module.exports = __webpack_public_path__ + "img/category-Fantasy.eb612a26.svg";